import { observer } from "mobx-react-lite";
import { ZoomControl } from "react-leaflet";
import FindTable from "./FindTable";
import CameraInfoPanel from "./info/CameraInfo";
import FeatureInfo from "./info/FeatureInfo";
import LightningInfo from "./info/LightningInfo";
import SensorInfo from "./info/SensorInfo";
import { IPanel } from "./models/Menus";
import { useRootStore } from "./models/Root";
import { ISelectedSensor } from "./models/SelectedSensor";
import NavMenu from "./NavMenu";
import BookmarksPanel from "./panels/BookmarksPanel";
import LayersPanel from "./panels/LayersPanel";
import MeasurePanel from "./panels/MeasurePanel";
import RadarPanel from "./panels/RadarPanel";
import SensorsPanel from "./panels/SensorsPanel";
import TabularDataPane from "./panes/TabularData";
import LeafletMobileCard from "./shared/LeafletMobileCard";
import LeafletSidebar from "./shared/LeafletSidebar";

const MobileSensorInfo = ({ sensor }: { sensor: ISelectedSensor }) => {
  switch (sensor.pane) {
    case "summary":
      return <SensorInfo selected={sensor} />;
    case "tabular":
      return <TabularDataPane sensor={sensor.sensor} />;
    default:
      return <> </>;
  }
};

const MobileCard = observer(() => {
  const getPanel = (panel: IPanel) => {
    switch (panel) {
      case "layers":
        return LayersPanel;
      case "bookmarks":
        return BookmarksPanel;
      case "measure":
        return MeasurePanel;
      case "sensors":
        return SensorsPanel;
      case "radar":
        return RadarPanel;
      case "find":
        return FindTable;
    }
  };

  const {
    menus: { panel },
    sensors: { selected: selectedSensor },
    layers: { selectedCamera, selectedFeature, lightning },
  } = useRootStore();

  if (selectedSensor) {
    return (
      <LeafletMobileCard>
        <MobileSensorInfo sensor={selectedSensor} />
      </LeafletMobileCard>
    );
  } else if (selectedFeature) {
    return (
      <LeafletMobileCard>
        <FeatureInfo feature={selectedFeature} />
      </LeafletMobileCard>
    );
  } else if (
    lightning &&
    (lightning.showLegend || lightning.selected !== undefined)
  ) {
    return (
      <LeafletMobileCard>
        <LightningInfo lightning={lightning} legend={false} />
      </LeafletMobileCard>
    );
  } else if (selectedCamera !== undefined) {
    return (
      <LeafletMobileCard>
        <CameraInfoPanel camera={selectedCamera} />
      </LeafletMobileCard>
    );
  } else if (panel && panel !== "find") {
    const Panel = getPanel(panel);
    return (
      <LeafletMobileCard>
        <Panel />
      </LeafletMobileCard>
    );
  } else if (panel === "find") {
    return (
      <LeafletMobileCard>
        <FindTable />
      </LeafletMobileCard>
    );
  } else {
    return <> </>;
  }
});

const Nav = observer(() => {
  const {
    menus: { nav },
  } = useRootStore();

  if (!nav) {
    return <></>;
  }

  return (
    <LeafletSidebar side="left" size="narrow">
      <div className="leaflet-control narrow">
        <NavMenu></NavMenu>
      </div>
    </LeafletSidebar>
  );
});

const Mobile = () => {
  return (
    <>
      <ZoomControl position="topright" />
      <Nav />
      <MobileCard />
    </>
  );
};

export default Mobile;
